import { PartitionAssignICountState } from './PartitionAssignICountState';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { IQuickSortState } from '../../IQuickSortState';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { IQuickSortContext } from '../../IQuickSortContext';

export class PartitionAssignPivotState implements IQuickSortState {
  
  ThisQuickSortStep = QuickSortStep.PartitionAssignPivot;

  Description = "Assign pivot value";

  private _savedState : { Pivot : number | undefined } | undefined;

  private _context : IQuickSortContext | undefined;

  Do(): void {
    if (this._savedState === undefined) {
      this._savedState = {
        Pivot: this._context?.Pivot
      }
    }
    else {
      this._savedState.Pivot = this._context?.Pivot;
    }
    
    if (this._context && this._context.Numbers && this._context.Hi) {
      this._context.Pivot = this._context.Numbers[this._context.Hi];
    }
  }  
  
  Undo(): void {
    if (this._savedState && this._context && this._context.Numbers && this._context.Hi) {
      this._context.Pivot = this._savedState.Pivot;
    }
  }

  Exit(): void {
    this._context?.TransitionTo(new PartitionAssignICountState());
  }

  SetContext(context: IQuickSortContext): void {
    this._context = context;
  }
}